/**
 * 投稿成功後の履歴保存を行う。補助的な永続化の失敗で、確定済みの投稿を
 * エラー扱いへ戻さないため、保存例外はこの境界で終了させる。
 */
export function recordSuccessfulPost(
  addPosted: (boardSlug: string, threadId: string) => void,
  boardSlug: string,
  threadId: string,
): void {
  try {
    addPosted(boardSlug, threadId);
  } catch {
    // 履歴は補助情報のため、保存不能でもサーバーの成功結果を優先する。
  }
}

export type SuccessfulPostMode = "reply" | "thread";

/** PC版でフォームが閉じた後も残る成功通知を表示する。 */
export function notifyDesktopSubmitSuccess(
  mode: SuccessfulPostMode,
  isDesktop: boolean,
  notify: (message: string) => void,
): void {
  if (!isDesktop) return;
  notify(mode === "reply" ? "レスを送信しました" : "スレッドを作成しました");
}
